module.exports = __webpack_public_path__ + "img/feedback6-1.00cc3ef2.jpg";